import { apiBlobRequest, apiRequest } from './http';
import type { ApiItemResponse, ApiListResponse } from '../types/api';

export interface EtatChargementListQuery {
  page?: number;
  pageSize?: number;
  referenceEc?: string;
  partnerCode?: string;
  fonctionMessage?: string;
  validationStatus?: string;
  processingStatus?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface EtatChargementListItem {
  id: string;
  filename: string | null;
  partnerCode: string | null;
  referenceEc: string | null;
  fonctionMessageCode: string | null;
  fonctionMessageLabel: string;
  numeroVersion: number | null;
  dateEnregistrementRaw: string | null;
  dateEnregistrementTimestamp: string | null;
  bureauSortie: string | null;
  validationStatus: string;
  processingStatus: string;
  processingError: string | null;
  correlationId: string;
  inboundDocumentId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface EtatChargementTransportMean {
  id: string;
  pays: string | null;
  typeMoyenCode: string | null;
  immatriculation: string | null;
  tare: string | null;
}

export interface EtatChargementDeclaration {
  id: string;
  referenceDum: string | null;
  numVoyage: string | null;
  annexe: string | null;
  natureMarchandise: string | null;
}

export interface EtatChargementDetail extends EtatChargementListItem {
  technicalMessageNumber: string;
  as2MessageId: string | null;
  rootElement: string;
  numeroMessage: string | null;
  dateDepotRaw: string | null;
  dateBonEmbarqueRaw: string | null;
  modeTransportCode: string | null;
  rawXmlAvailable: boolean;
  normalizedJson: Record<string, unknown> | null;
  validationReport: { errors?: string[]; warnings?: string[] } | null;
  timeline: Array<{ at: string; status: string; detail?: string }>;
  children: {
    transportMeans: EtatChargementTransportMean[];
    declarations: EtatChargementDeclaration[];
  };
}

function queryString(query: EtatChargementListQuery): string {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') search.set(key, String(value));
  });
  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

export async function listEtatChargementMessages(query: EtatChargementListQuery): Promise<ApiListResponse<EtatChargementListItem>> {
  return apiRequest<ApiListResponse<EtatChargementListItem>>(`/customs/etat-chargement${queryString(query)}`);
}

export async function getEtatChargementMessage(id: string): Promise<EtatChargementDetail> {
  const response = await apiRequest<ApiItemResponse<EtatChargementDetail>>(`/customs/etat-chargement/${id}`);
  return response.data;
}

export async function getEtatChargementRawXml(id: string): Promise<string> {
  const { blob } = await apiBlobRequest(`/customs/etat-chargement/${id}/raw`);
  return blob.text();
}
